import { ActionStatus } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-components/Form'
import { T } from '@tribeplatform/react-components/i18n'
import { useSendResetPasswordEmail } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Text } from '@tribeplatform/react-ui-kit/Text'

type ForgotPasswordFormProps = {
  onSend: (emailAddress: string) => void
}

export const ForgotPasswordForm = ({ onSend }: ForgotPasswordFormProps) => {
  const { mutateAsync: sendResetPasswordEmail, isLoading } =
    useSendResetPasswordEmail()

  const onSubmit = async (data: { email: string }) => {
    const res = await sendResetPasswordEmail({ email: data.email })
    if (res.status === ActionStatus.succeeded) {
      onSend(data.email)
    }
  }
  return (
    <div className="lg:w-1/2 md:w-full flex mx-auto flex-col py-8 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Text
          as="h2"
          variant="headingLg"
          align="center"
          onBackground
          className="mt-6"
        >
          <T
            defaultMessage="Forgot your password?"
            id="Generics.ForgotYourPassword"
          />
        </Text>
        <p className="mt-3 text-lg text-center text-content-on-background-subdued">
          <T
            defaultMessage="Enter your email below and we will{br}send you a link to reset it."
            id="Auth.ForgotPass.Instruct"
          />
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card className="py-8 px-4">
          <Form className="space-y-5" onSubmit={onSubmit}>
            <Form.Input
              autoComplete="email"
              label={<T defaultMessage="Email" id="Generics.Email" />}
              name="email"
              autoFocus
            />
            <div>
              <Button
                fullWidth
                variant="primary"
                type="submit"
                loading={isLoading}
                size="lg"
              >
                <T
                  defaultMessage="Send reset link"
                  id="Auth.ForgotPass.Actions.SendLink"
                />
              </Button>
            </div>
          </Form>
        </Card>
      </div>
    </div>
  )
}
